<div id="tmExtCnt" class="mod-cnt-ext">
    <div class="mod-cnt" [ngClass]="{'mod-cnt-mobile' : isMobile}">
        <div class="mod-cnt-title">
            <div class="mod-ico-cnt">
                <i class="fas fa-question-circle mod-icon"></i>
            </div>
            <span class="te-title">{{'enquiryBook.editInPlace' | translate}}</span>
        </div>
        <div class="mod-cnt-body">
            <span class="te-message" [innerHTML]="'commons.confirmPendingChanges' | translate"></span>
        </div>
        <div class="mod-cnt-btn" [ngClass]="{'mod-cnt-btn-mobile' : isMobile}">
            <!-- CONFIRM -->
            <teiasoft-button (onClick)="onApplyModalClick()" class="mr-5" [type]="'tb-secondary'" [text]="'commons.apply' | translate"  [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <!-- DISCARD -->
            <teiasoft-button (onClick)="onDiscardModalClick()" class="mr-5" [type]="'tb-primary'" [text]="'commons.discard' | translate"  [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <!-- CLOSE -->
            <teiasoft-button (onClick)="onCloseModalClick()" [text]="'commons.cancel' | translate" [theme]="theme" [isMobile]="isMobile" [type]="'tb-cancel'"></teiasoft-button>
        </div>
    </div>
</div>
